//
// Module for the Manual wizard's Initiate step
//
rs.module("participant/benefit/setup/manual/wizard/initiatestep",

    ["common/visibility", "common/select-helper"],

    function (visibility, selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, backendUrls, flags) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);

            var claimTypeHidden = stepContainer.js(jsSelectors.claimTypeHidden);

            var separationTypeSelect = stepContainer.js(jsSelectors.separationTypeSelect);
            var separationSubTypeContainer = stepContainer.js(jsSelectors.separationSubTypeContainer, { required: false });
            var separationSubTypeSelect = separationSubTypeContainer.js(jsSelectors.separationSubTypeSelect, { required: false });
            var separationSubTypeSelectHelper = selectHelper.getHelper(separationSubTypeSelect);
            var basisPlanSelect = stepContainer.js(jsSelectors.basisPlanSelect, { required: false });
            var basisPlanSelectHelper = selectHelper.getHelper(basisPlanSelect);
            var splitPlanCheckbox = stepContainer.js(jsSelectors.splitPlanCheckbox);
            var benefitEffectiveDateInput = stepContainer.js(jsSelectors.benefitEffectiveDateInput, { required: false });
            var dropBenefitEffectiveDate = stepContainer.js(jsSelectors.dropBenefitEffectiveDate, { required: false });
            var dropPlanSelect = stepContainer.js(jsSelectors.dropPlanSelect, { required: false });
            var dropPlanSelectHelper = selectHelper.getHelper(dropPlanSelect);
            var sourceBenefitSelect = stepContainer.js(jsSelectors.sourceBenefitSelect, { required: false });
            var benefitTypeSelect = stepContainer.js(jsSelectors.benefitTypeSelect);
            var benefitTypeSelectHelper = selectHelper.getHelper(benefitTypeSelect);

            // Hookup separationTypeSelect change event
            separationTypeSelect.change(separationTypeChange);

            // On Sub Type change, update benefit types
            separationSubTypeSelect.change(updateBenefitTypeSelect);

            // Hookup basisPlanSelect change event
            basisPlanSelect.change(basisPlanChange);

            // Hookup benefitEffectiveDateInput change event
            benefitEffectiveDateInput.change(_.debounce(function () { benefitEffectiveDateChange(); }, 500));

            // Hookup dropBenefitEffectiveDate change event
            dropBenefitEffectiveDate.change(_.debounce(function () { dropBenefitEffectiveDateChange(); }, 500));

            // On DROP Plan change, update benefit types
            dropPlanSelect.change(updateBenefitTypeSelect);

            // On Source Benefit change, 
            sourceBenefitSelect.change(sourceBenefitChange);

            // Separation Type change event
            function separationTypeChange() {

                // only alter visibility of Separation Sub Type if we're processing a retirement claim
                if (flags.isRetirementClaimType) {

                    // Get selected Separation Type
                    var selectedSeparationType = separationTypeSelect.val();

                    // Clear Separation Sub Type errors
                    separationSubTypeSelect.clearErrors();

                    // Reset Separation Sub Type selection
                    separationSubTypeSelectHelper.setValue("");

                    // Show/hide Separation Sub Type based on selected Separation Type
                    visibility.setVisible(separationSubTypeContainer, selectedSeparationType == codeValues.disabilityRetirement);
                }

                updateBenefitTypeSelect();
            }

            // Basis Plan change event
            function basisPlanChange() {
                if (flags.isDeathClaimType) {
                    updateBenefitTypeSelect();
                }
            }

            // Benefit Effective Date change event
            function benefitEffectiveDateChange() {

                updateBenefitTypeSelect();
            }

            // DROP Entry Date change event
            function dropBenefitEffectiveDateChange() {

                if (dropBenefitEffectiveDate.val() && dropBenefitEffectiveDate.valid()) {

                    // reload DROP plans
                    dropPlanSelectHelper.loadOptionsFrom(
                        backendUrls.getDropPlans,
                        {
                            dropEntryDate: dropBenefitEffectiveDate.val(),
                            selectedDropPlanKey: dropPlanSelect.val()
                        },
                        {
                            withBlank: true
                        },
                        function () {
                            // if plans exist, update Benefit Types
                            if (this.getOptions().length > 0) {
                                updateBenefitTypeSelect();
                            }
                        });
                }
            }

            // Update the options presented for benefit type
            function updateBenefitTypeSelect() {

                benefitTypeSelect.clearErrors();

                var basisPlan = basisPlanSelect.val();
                var separationType = separationTypeSelect.val();
                var separationSubType = separationSubTypeSelect.val();
                var benefitEffectiveDate = benefitEffectiveDateInput.val() && benefitEffectiveDateInput.valid() ? benefitEffectiveDateInput.val() : dropBenefitEffectiveDate.val();

                if (basisPlan &&
                    separationType &&
                    (separationSubTypeContainer.length === 0 || separationSubType || !separationSubTypeContainer.is(':visible')) &&
                    benefitEffectiveDate) {

                    // preserve selection
                    var currentSelection = benefitTypeSelect.val();

                    benefitTypeSelectHelper.loadOptionsFrom(
                        backendUrls.getBenefitTypes,
                        {
                            claimType: claimTypeHidden.val(),
                            benefitEffectiveDate: benefitEffectiveDate,
                            basisPlanKey: basisPlan,
                            separationType: separationType,
                            separationSubType: separationSubType,
                            dropPlanKey: dropPlanSelect.val()
                        },
                        {
                            withBlank: true
                        });

                    if (currentSelection) {
                        benefitTypeSelectHelper.setValue(currentSelection);
                    }

                } else {
                    benefitTypeSelectHelper.clearOptions();
                }
            }

            // Update Basis Type select, Benefit Type select, and Split Plan checkbox
            function sourceBenefitChange() {

                basisPlanSelect.clearErrors();
                benefitTypeSelect.clearErrors();

                var sourceBenefit = sourceBenefitSelect.val();
                var separationType = separationTypeSelect.val();
                var separationSubType = separationSubTypeSelect.val();

                if (sourceBenefit && separationType && separationSubType) {

                    $.get(
                        backendUrls.getBasisPlans,
                        {
                            claimType: claimTypeHidden.val(),
                            claimPaymentSourceKey: sourceBenefit,
                            separationType: separationType,
                            separationSubType: separationSubType
                        },
                        function (data) {
                            // suppressChange: true to prevent firing of basisPlanChange
                            basisPlanSelectHelper.replaceOptions(data.basisPlans, { suppressChange: true });
                            benefitTypeSelectHelper.replaceOptions(data.benefitTypes, { withBlank: true });

                            splitPlanCheckbox.prop('disabled', data.basisPlans.length <= 1);
                        }
                    );

                } else {
                    basisPlanSelectHelper.clearOptions();
                    benefitTypeSelect.clearOptions();

                    splitPlanCheckbox.prop('disabled', true);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);